import getAvatarUrl from "./getAvatarUrl";

/**
 * Renvoie l'URL d'aperçu pour l'avatar existant si présent,
 * sinon `null` (pour afficher le placeholder dans l'Upload).
 */
export default function getExistingAvatarPreview(user = {}, medical = {}) {
  const has =
    (medical?.avatar && typeof medical.avatar === "string") ||
    (user?.avatar && typeof user.avatar === "string");

  if (!has) return null;
  return getAvatarUrl(user, medical);
}